<template>
  <div>
    <div id="container" :style="style">
      <i
        class="fa fa-spinner spin fa-2x text-white"
        v-if="waiting"
        :style="{ 'margin-top': mspin }"
      ></i>
      <iframe :src="src" v-if="!waiting" :style="style"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paymentAdjustmentPDF',
  props: {
    src: {
      type: String,
      default: null
    },
    waiting: {
      type: Boolean,
      default: false
    },
    width: {
      type: String | Number,
      default: '100%'
    },
    height: {
      type: String | Number,
      default: '378px'
    },
    mspin: {
      type: String | Number,
      default: '20vh'
    }
  },
  data() {
    return {}
  },
  computed: {
    style() {
      return {
        width: this.width,
        height: this.height
      }
    }
  }
}
</script>

<style scoped>
#container {
  background: black;
  text-align: center;
}
#container iframe {
  border: 2px solid #acacac;
}
</style>
